// extracted by mini-css-extract-plugin
export default {"container":"CurrencyList_container__4IW1n","itemsContainer":"CurrencyList_itemsContainer__vO5Rz","text":"CurrencyList_text__msLr2"};